module.exports = __webpack_public_path__ + "static/media/Protones - Logo Rosso Scuro.390b71fe.png";